import { defineMessages } from 'react-intl';

export default defineMessages({
	helpfulPageHeading: {
		id: 'ai-answer.feedback-form.helpful-page-heading',
		defaultMessage: 'Awesome!',
		description: 'Heading for the feedback form helpful page',
	},
	helpfulPageSubHeading: {
		id: 'ai-answer.feedback-form.helpful-page-sub-heading',
		defaultMessage: 'Glad we could help.',
		description: 'Subheading for the feedback form helpful page',
	},
	nonHelpfulPageHeading: {
		id: 'ai-answer.feedback-form.non-helpful-page-heading',
		defaultMessage: 'Sorry, it wasn’t helpful.',
		description: 'Heading for the feedback form non-helpful page',
	},
	nonHelpfulPageSubHeading: {
		id: 'ai-answer.feedback-form.non-helpful-page-sub-heading',
		defaultMessage: "We're working on your request.",
		description: 'Subheading for the feedback form non-helpful page',
	},
	// eslint-disable-next-line rulesdir/i18n-unique-message-ids
	additionalFeedbackCTALabel: {
		id: 'ai-answer.feedback-form.additional-feedback-label',
		defaultMessage: 'Give additional feedback',
		description: 'Label for the additional feedback button',
	},
	feedbackTitle: {
		id: 'ai-answer.feedback-form.feedback-title',
		defaultMessage: 'Help us improve',
		description:
			'The text is shown as the title heading of the feedback dialog that appears when a user wants to provide feedback on an AI-generated answer.',
	},
	sendFeedbackLabel: {
		defaultMessage: 'Send Feedback',
		description: 'Feedback dialog Submit button label',
		id: 'ai-answer.feedback-form.feedback-submit-button-label',
	},
	cancelLabel: {
		defaultMessage: 'Cancel',
		description: 'Feedback dialog cancel button label',
		id: 'ai-answer.feedback-form.feedback-cancel-button-label',
	},
	contactLabel: {
		defaultMessage: 'Contact me for more details about this feedback',
		description: 'Feedback dialog can contact label',
		id: 'ai-answer.feedback-form.feedback-can-contact-label',
	},
	summary: {
		defaultMessage: 'Summary',
		description: 'Feedback dialog summary label',
		id: 'ai-answer.feedback-form.feedback-summary',
	},
	subHeading: {
		defaultMessage: 'Required fields are marked with an asterisk',
		description: 'Feedback dialog sub heading',
		id: 'ai-answer.feedback-form.feedback-sub-heading',
	},
	genericErrorMessage: {
		defaultMessage:
			'Looks like we’re having trouble retrieving some information, please refresh the page.',
		description: 'Generic error when something could not be loaded',
		id: 'ai-answer.feedback-form.generic-heading',
	},
	genericRedirectMessage: {
		defaultMessage: 'Go to the portal.',
		description: 'Generic redirect link message when something could not be loaded',
		id: 'ai-answer.feedback-form.generic-redirect-message',
	},
	summaryPlaceholder: {
		defaultMessage: "Let us know what's on your mind",
		description: 'Message which will be shown inside the summary text field',
		id: 'ai-answer.feedback-form.feedback-summary-placeholder',
	},
	enrolInResearchLabel: {
		defaultMessage: "I'd like to participate in product research",
		description: 'Message which will be shown next to the enrol in research checkbox',
		id: 'ai-answer.feedback-form.feedback-enrol-in-research-label',
	},
});
